module.exports = __webpack_public_path__ + "media/images/flags/64/Palau-f926721b38dbcb8c80002393142ad03b.png";